<template>
  <div>
    <div class="flex items-center">
      <div
        class="flex md:grid grid-cols-4 gap-5 md:gap-5 overflow-x-scroll w-11/12 md:w-full py-5"
      >
        <button
          v-for="(tab, index) in tabs"
          :key="tab.title"
          @click="selectTab(index)"
          class="md:rounded md:shadow md:p-3 flex items-center md:block gap-2 flex-shrink-0 flex-row-reverse"
          :class="
            tab.isActive
              ? 'md:bg-blue-500 border-0'
              : 'md:bg-gray-400 md:border border-blue-300'
          "
        >
          <div
            v-if="tab.icon"
            class="hidden mb-5 h-16 lg:h-32 mx-auto md:flex justify-center"
            :class="tab.isActive ? 'text-white' : 'text-blue-600'"
            v-html="tab.icon"
          ></div>
          <div
              v-else
              class="md:h-36 py-4 flex items-center justify-center"
          >
            <img
                :src="tab.image"
                :alt="tab.title"
                class="hidden md:block max-h-full max-w-full"
            />
          </div>
          <h3
            class="text-sm md:text-xl md:font-semibold"
            :class="
              tab.isActive
                ? 'text-blue-600 md:text-white'
                : 'text-gray-500 md:text-blue-600'
            "
            v-text="tab.title"
          ></h3>
        </button>
      </div>
      <div class="w-1/12 md:hidden">
        <svg
          class="m-auto w-5 h-5 stroke-current text-blue-500 feather feather-arrow-right-circle"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 16 16 12 12 8"></polyline>
          <line x1="8" y1="12" x2="16" y2="12"></line>
        </svg>
      </div>
    </div>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AssortmentTabs',
  data() {
    return {
      selectedIndex: 0,
      tabs: [],
    };
  },
  created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.tabs[0].isActive = true;
  },
  methods: {
    selectTab(i) {
      this.selectedIndex = i;

      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i;
      });
    },
  },
};
</script>
